import { AGENT_RAN_LABEL } from '../lib/agents.js'
import { timeAgo } from '../lib/format.js'

// AgentRanBadge — the single shared "Agent ran · 2 hr ago" badge shown
// next to AI surfaces that carry a generated_at timestamp (Ship 8).
//
// TEXT-ONLY, muted — no icons, no AI-cost language. Renders nothing when
// there's no usable timestamp (null/undefined/unparseable/future), so a
// host card never shows "NaN"/"Invalid Date".
//
// Props:
//   generatedAt — ISO timestamp string (or null) of the last run
//   tone        — 'light' (default, for white cards) | 'dark' (for the
//                 charcoal hero cards). Controls muted text color only.
//
// Place inside the host card's existing top-right flex row.
export default function AgentRanBadge({ generatedAt, tone = 'light' }) {
  if (!generatedAt) return null
  const ago = timeAgo(generatedAt)
  if (!ago) return null

  const color =
    tone === 'dark' ? 'text-charcoal-text-secondary' : 'text-black/40'

  return (
    <span className={`text-[10px] font-medium ${color}`}>
      {AGENT_RAN_LABEL} · {ago}
    </span>
  )
}
